import { Link, useNavigate } from "react-router-dom";
import { ChevronDown, FolderOpen, LayoutDashboard, LogIn, LogOut } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useAuth } from "@/context/AuthContext";

const Avatar = ({ user }) =>
  user.picture ? (
    <img src={user.picture} alt="" className="h-7 w-7 rounded-full object-cover" referrerPolicy="no-referrer" />
  ) : (
    <span className="flex h-7 w-7 items-center justify-center rounded-full bg-emerald-500 text-xs font-bold text-white">
      {user.name.slice(0, 1).toUpperCase()}
    </span>
  );

export const UserMenu = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  if (user === null) return null;
  if (!user) {
    return (
      <Button asChild size="sm" className="h-9 rounded-full bg-emerald-500 px-4 font-semibold text-white hover:bg-emerald-400">
        <Link to="/masuk" data-testid="header-login-btn"><LogIn className="h-4 w-4" /> Masuk</Link>
      </Button>
    );
  }
  const signOut = async () => {
    await logout();
    toast.success("Anda telah keluar");
    navigate("/");
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" className="flex items-center gap-2 rounded-full bg-white/10 py-1 pl-1 pr-2.5 text-sm text-white ring-1 ring-white/15 transition-colors hover:bg-white/15" data-testid="user-menu-trigger">
          <Avatar user={user} />
          <span className="hidden max-w-[140px] truncate sm:inline">{user.name}</span>
          <ChevronDown className="h-4 w-4 text-slate-300" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-60 bg-white">
        <DropdownMenuLabel className="space-y-0.5">
          <p className="truncate text-sm font-semibold text-slate-900" data-testid="user-menu-name">{user.name}</p>
          <p className="truncate text-xs font-normal text-slate-500">{user.email}</p>
          <p className="text-xs font-semibold text-emerald-700" data-testid="user-menu-role">{user.role === "admin" ? "Admin RT" : "Warga"}</p>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {user.role === "admin" ? (
          <DropdownMenuItem onSelect={() => navigate("/admin")} data-testid="menu-dashboard"><LayoutDashboard className="h-4 w-4" /> Dashboard Admin RT</DropdownMenuItem>
        ) : (
          <DropdownMenuItem onSelect={() => navigate("/pengaduan-saya")} data-testid="menu-my-complaints"><FolderOpen className="h-4 w-4" /> Pengaduan Saya</DropdownMenuItem>
        )}
        <DropdownMenuItem onSelect={signOut} className="text-rose-600 focus:text-rose-700" data-testid="menu-logout"><LogOut className="h-4 w-4" /> Keluar</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
